import React, { forwardRef } from 'react';
import { YStack } from 'tamagui';

import { LABEL_TEXT_COLOR } from '../controlled/ControlledInput';
import { LabelRegular } from '../text/Typography';
import { Input, type InputProps } from './Input';

export const MultilineInput = forwardRef<
    React.ElementRef<typeof Input>,
    InputProps & { numberOfLines?: number }
>(({ numberOfLines = 3, height, ...props }, ref) => {
    const { label, containerProps } = props;
    const defaultHeight = numberOfLines * 22 + 32; // approx line height + vertical padding

    return (
        <YStack gap={8} {...containerProps}>
            {label != null && (
                <LabelRegular color={LABEL_TEXT_COLOR} marginLeft={16}>
                    {label}
                </LabelRegular>
            )}
            <Input
                {...props}
                ref={ref}
                width="100%"
                minWidth={0}
                height={height ?? defaultHeight}
                fontWeight="regular"
                numberOfLines={numberOfLines}
                multiline
                textAlignVertical="top"
            />
        </YStack>
    );
});
